import { useEffect, useState } from "react";

const READING_LINE_RATIO = 0.38;
const BOTTOM_TOLERANCE_PX = 4;

const isAtPageBottom = () =>
  window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - BOTTOM_TOLERANCE_PX;

/** Returns the nav id of the last section whose top edge has crossed the reading line. */
const resolveActiveId = (ids) => {
  const line = window.scrollY + window.innerHeight * READING_LINE_RATIO;
  let current = ids[0];
  let bestTop = -Infinity;

  document.querySelectorAll("[data-section-id]").forEach((node) => {
    const id = node.getAttribute("data-section-id");
    if (!ids.includes(id)) return;
    const top = node.getBoundingClientRect().top + window.scrollY;
    if (top <= line && top > bestTop) {
      bestTop = top;
      current = id;
    }
  });

  return isAtPageBottom() ? ids[ids.length - 1] : current;
};

/**
 * Tracks which nav section is active based on scroll position.
 * Every element carrying `data-section-id` maps to a nav id (several sections may share one id).
 */
export function useActiveSection(ids) {
  const [active, setActive] = useState(ids[0]);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    let frame = 0;

    const update = () => {
      frame = 0;
      setActive(resolveActiveId(ids));
    };
    const schedule = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);
    return () => {
      window.removeEventListener("scroll", schedule);
      window.removeEventListener("resize", schedule);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, [ids]);

  return active;
}
